import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { Translate, withLocalize } from "react-localize-redux";
import { bindActionCreators } from 'redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { domainActions } from '../../store/domainStore';
import ModalInner from '../layoutItems/modalInner';
import ResponsiveTable from '../layoutItems/responsiveTable';
import { REGISTRY } from '../../store/ceeSearchStore';
import BbCheckbox from '../styling/bbFormikCheckbox';
import BbDatePicker from '../common/datePicker';
import { hasPermission } from '../../store/apiWrapper';
import UnderlinedTitle from '../common/underlinedTitle';
import { Formik, Field, Form } from 'formik';
import { registrySearchActions } from '../../store/ceeSearchStore';
import { windowActions } from '../../store/windowStore';
import { number as YupNumber, object as YupObject } from '../common/Yup';
import Message from '../common/message';
import moment from 'moment';

const CAUSE_AMOUNT_MIN = 0;
const CAUSE_AMOUNT_MAX = 9999999999;
const CAUSES_MIN = 1;
const CAUSES_MAX = 100;
const CAUSES_MAX_TOTAL = 100000;
const YEAR_MIN = 0;

class PortfolioCeeCreMonetaryObligationPopup extends React.Component {

    state = {
        formData: null
    }

    componentDidMount() {
        const settings = this.props[this.props.registry].settings;
        if (isNullOrUndefined(settings) || isNullOrUndefined(settings[`${this.props.registry}${'MaxNumberOfCauses'}`]) || isNullOrUndefined(settings[`${this.props.registry}${'CasesNotOlderThan'}`])) {
            this.props.searchFormLoaded(this.props.registry);
        }
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const wrongMaxCauses = this.props.translate("Search.Cee.ValidationError.MaxCauses");

        return YupObject().shape({
            maxCauses: YupNumber().notRequired()
                .when('includeMonetary', {
                    is: (val) => val == true,
                    then: fieldSchema => fieldSchema.required(wrongInputMsg),
                })
                .test('monetary', wrongMaxCauses, function (item) {
                    return isNullOrUndefined(item) || this.parent.includeMonetary === false || isNullOrUndefined(this.parent.maxTotalCauses) ||
                        (!isNullOrUndefined(this.parent.maxTotalCauses) && (item <= this.parent.maxTotalCauses))
                })
        });
    }

    render() {
        return (
            <React.Fragment>
                <ModalInner title={this.props.translate('Search.Common.Bulk')} close={this.props.close}>
                    <React.Fragment>
                        <ResponsiveTable>
                            {((this.props.registry === REGISTRY.cee && hasPermission(null, "CEEenhancedCz")) || (this.props.registry === REGISTRY.cre && hasPermission(null, "CREEnhancedSk"))) && (
                                <Formik
                                    ref={(el) => this.formRef = el}
                                    enableReinitialize
                                    validationSchema={this.createValidationSchema()}
                                    validateOnChange={false}
                                    validateOnBlur={false}
                                    initialValues={{
                                        includeMonetary: false,
                                        maxCauses: this.getFromCustomerSettings("MaxNumberOfCauses"),
                                        maxTotalCauses: this.getFromCustomerSettings("MaxNumberOfDetails"),
                                        minCauseDate: this.getFromCustomerSettings("CasesNotOlderThan"),
                                        minCauseAmount: this.getFromCustomerSettings("MinMonetaryObligation"),

                                    }}
                                    onSubmit={(values, { setSubmitting }) => {
                                        setSubmitting(false); // 'loading' status is handled by Redux so immediately reset Formik's 'submitting' flag
                                        this.props.search(values);
                                    }}>
                                    {({ values, errors, setFieldValue }) => (
                                        <Form>


                                            {Object.keys(errors).length > 0 && <div className="column" style={{ paddingTop: "0em" }}>

                                                {Object.keys(errors).find(key => key === "maxCauses" && errors[key] === this.props.translate("Search.Cee.ValidationError.MaxCauses")) &&
                                                    <Message type="error" message={this.props.translate("Search.Cee.ValidationError.MaxCauses")} style={{ marginTop: "0.75em" }}></Message>
                                                }
                                            </div>}
                                            {this.props.registry === 'cee' && <span><Translate id={'Portfolio.MonetaryObligationPopup.CEE'} options={{ renderInnerHtml: true }} /></span>}
                                            {this.props.registry === 'cre' && <span><Translate id={'Portfolio.MonetaryObligationPopup.CRE'} options={{ renderInnerHtml: true }} /></span>}

                                            <div className="column is-12 has-text-centered" style={{ borderTop: "1px solid rgb(222, 222, 222)", paddingTop: "1.5em" }}>
                                                <UnderlinedTitle header={this.props.translate("Search.Common.MonetaryInfoAutodownload")} />
                                                <div className="columns is-mobile" style={{ marginTop: ".1em", marginBottom: "0em" }}>
                                                    <div className="column" style={{ display: "flex", lineHeight: "3em", alignItems: "center", flexWrap: "wrap" }}>
                                                        <span className="aml-special-span" >
                                                            <BbCheckbox style={{ display: "inline-flex", minHeight: "0px", lineHeight: "3em", verticalAlign: "middle" }}
                                                                id='includeMonetary'
                                                                name='includeMonetary'
                                                                value={values.includeMonetary}
                                                                label={this.props.translate("Search.Common.DownloadMonetaryObligationPart1")} />
                                                            <Field
                                                                className="input"
                                                                type='number'
                                                                min={CAUSES_MIN}
                                                                max={CAUSES_MAX}
                                                                name="maxCauses"
                                                                style={{ maxWidth: '4em', display: 'inline-block', marginLeft: '.5em', marginRight: '.5em', textAlign: "center" }}
                                                                disabled={!values.includeMonetary}
                                                                onChange={e => this.onNumberChanged("maxCauses", e.target.value, setFieldValue, CAUSES_MIN, CAUSES_MIN, CAUSES_MAX)}
                                                            />
                                                            <span>
                                                                <Translate id='Search.Common.DownloadMonetaryObligationPart2' />
                                                                <Translate id='Search.Common.DownloadMonetaryObligationPart3' />
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="columns is-mobile has-text-left">
                                                    <div className="column is-12">
                                                        <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                            <div className='field bb-field'>
                                                                <div className="control">
                                                                    <div className="columns">
                                                                        <div className="column column bb-input-label-column is-one-third">
                                                                            <div className="vertically-centered">
                                                                                <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                                                    <span><Translate id="Search.Common.TotalNumberOfCasesNotExceeding" /></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="column bb-input-column is-two-thirds">
                                                                            <Field
                                                                                className="bb-input-expanded input form-control"
                                                                                type="number"
                                                                                min={CAUSES_MIN}
                                                                                max={CAUSES_MAX_TOTAL}
                                                                                name="maxTotalCauses"
                                                                                disabled={!values.includeMonetary}
                                                                                onChange={e => this.onNumberChanged("maxTotalCauses", e.target.value, setFieldValue, null, CAUSES_MIN, CAUSES_MAX_TOTAL)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.props.registry === REGISTRY.cee && <div className='field bb-field'>
                                                            <div className="control">
                                                                <div className="columns">
                                                                    <div className="column column bb-input-label-column is-one-third">
                                                                        <div className="vertically-centered">
                                                                            <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                                                <span><Translate id="Search.Common.CaseNotOlderThan" /></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="column bb-input-column is-two-thirds">
                                                                        <BbDatePicker
                                                                            formik={this.formRef}
                                                                            field={'minCauseDate'}
                                                                            value={values.minCauseDate}
                                                                            disabled={!values.includeMonetary}
                                                                            formDateFormat={"YYYY-MM-DD"}
                                                                            yearsBack={120}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                        {this.props.registry === REGISTRY.cre && <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                            <div className='field bb-field'>
                                                                <div className="control">
                                                                    <div className="columns">
                                                                        <div className="column column bb-input-label-column is-one-third">
                                                                            <div className="vertically-centered">
                                                                                <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                                                    <span><Translate id="Search.Common.CaseNotOlderThan" /></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="column bb-input-column is-two-thirds">
                                                                            <Field
                                                                                className="bb-input-expanded input form-control"
                                                                                type="number"
                                                                                min={YEAR_MIN}
                                                                                max={new Date().getFullYear()}
                                                                                name="year"
                                                                                disabled={!values.includeMonetary}
                                                                                onChange={e => this.onNumberChanged("year", e.target.value, setFieldValue, null, YEAR_MIN, new Date().getFullYear())}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                        {this.props.registry === REGISTRY.cee && <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                            <div className='field bb-field'>
                                                                <div className="control">
                                                                    <div className="columns">
                                                                        <div className="column column bb-input-label-column is-one-third">
                                                                            <div className="vertically-centered">
                                                                                <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                                                    <span><Translate id="Search.Cee.MinAmountOfMonetaryObligationPart1" /></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="column bb-input-column is-two-thirds">
                                                                            <Field
                                                                                className="bb-input-expanded input form-control"
                                                                                type="number"
                                                                                min={CAUSE_AMOUNT_MIN}
                                                                                max={CAUSE_AMOUNT_MAX}
                                                                                name="minCauseAmount"
                                                                                disabled={!values.includeMonetary}
                                                                                onChange={e => this.onNumberChanged("minCauseAmount", e.target.value, setFieldValue, null, CAUSE_AMOUNT_MIN, CAUSE_AMOUNT_MAX)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-inner-buttons">
                                                <button type='submit' className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                                    <Translate id='Search.Common.Search' />
                                                </button>
                                            </div>
                                        </Form>)}
                                </Formik>
                            )}
                        </ResponsiveTable>
                    </React.Fragment>
                </ModalInner>
            </React.Fragment>
        )
    }

    getFromCustomerSettings = (settingName) => {
        const settings = this.props[this.props.registry].settings;
        if (isNullOrUndefined(settings))
            return "";

        const value = settings[`${this.props.registry}${settingName}`];
        return isNullOrUndefined(value) ? "" : this.props.registry === REGISTRY.cee && settingName === "CasesNotOlderThan" ? moment(value).format("YYYY-MM-DD") : value;
    }

    onNumberChanged = (fieldName, value, setFieldValue, defaultValue = null, min = null, max = null) => {
        let parsed = parseInt(value);
        if (isNullOrUndefined(parsed) || isNaN(parsed))
            parsed = defaultValue;
        if (!isNullOrUndefined(parsed) && !isNullOrUndefined(min) && !isNaN(min) && parsed < min)
            parsed = min;
        if (!isNullOrUndefined(parsed) && !isNullOrUndefined(max) && !isNaN(max) && parsed > max)
            parsed = max;
        setFieldValue(fieldName, isNullOrUndefined(parsed) ? "" : parsed);
    }
}
export default withLocalize(connect(
    state => { return { ...state.registrySearch, user: state.userContext, domain: state.domain } },
    dispatch => bindActionCreators({ ...registrySearchActions, ...windowActions, ...domainActions }, dispatch)
)(PortfolioCeeCreMonetaryObligationPopup));